// @ts-nocheck
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { Link } from 'react-router-dom'

interface NoDataFoundProps {
  heading: string
  text: string
  url: string
  linkText: string
  isExternal?: boolean
  testId?: string
}

const NoDataFound = ({
  heading,
  text,
  url,
  linkText,
  isExternal = true,
  testId
}: NoDataFoundProps) => (
  <EmptyState
    title={heading}
    icon={<NoDataIcon />}
    description={text}
    testId={testId}
  >
    {isExternal ? (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
    ) : (
      <Link to={url} target="_blank" rel="noreferrer">
        {linkText}
      </Link>
    )}
  </EmptyState>
)
export default NoDataFound
